import React, { Component } from 'react'

import Plyr from './plyr'
import Play from '../assets/images/play.svg'

class LatestVideos extends Component {

  state = {
    lightbox: false,
    video: '',
    showMore: false
  }

  openModal(source) {
    let url = this.getVideoID(source)
    this.setState({ 
      lightbox: true,
      video: url 
    })
  }

  getVideoID(url) {
    if (!url) return null
    let regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*).*/
    let match = url.match(regExp)
    return match && match.length > 1 && match[1]
  }

  render() {
    const { title, content, videos } = this.props
    let { lightbox, video, showMore } = this.state

    return (
      <section className='latest-videos'>
        <div className='latest-videos__inner'>
          <h3>{title}</h3>
          <div className='latest-videos__content' dangerouslySetInnerHTML={{ __html: content }} />
          { videos && videos.length > 0 &&
            <div className={`latest-videos__items ${showMore ? 'active' : ''}`}>
              { videos.map((el, i) => (
                <div className='latest-videos__item' key={i} onClick={() => this.openModal(el.video)}>
                  <picture>
                    <img src={el.thumb?.localFile?.publicURL} alt={'Whitefox Advocacy'} />
                    <div className='video__play'>
                      <span>Play</span>
                      <img src={Play} alt={'Whitefox - Play Video'} />
                    </div>
                    <span className='name'>{el.title}</span>
                  </picture>
                </div>
              )) }
            </div>
          }
          { !showMore && <button type='button' className='btn' onClick={() => this.setState({ showMore: !showMore })}>Load More</button> }
        </div>
        { lightbox && 
          <div className={`sp__lightbox ${lightbox ? 'active' : ''}`}>
            <div className='sp__lightbox__inner'>
              <svg onClick={() => this.setState({ lightbox: false })} className='close' width='25px' height='25px' viewBox='0 0 25 25' version='1.1' xmlns='http://www.w3.org/2000/svg'>
                <g stroke='none' strokeWidth='1' fill='#FFFFFF' fillRule='evenodd'>
                  <path d='M12.4893787,24.9492612 C5.60275148,24.9492612 1.0658141e-14,19.3531028 1.0658141e-14,12.4746158 C1.0658141e-14,5.59615839 5.60275148,-1.42108547e-14 12.4893787,-1.42108547e-14 C19.3760059,-1.42108547e-14 24.978787,5.59615839 24.978787,12.4746158 C24.978787,19.3531028 19.3760059,24.9492612 12.4893787,24.9492612 M12.4893787,1.02231087 C6.16715976,1.02231087 1.02352071,6.15986998 1.02352071,12.4746158 C1.02352071,18.7893913 6.16715976,23.9269504 12.4893787,23.9269504 C18.8115976,23.9269504 23.9552367,18.7893913 23.9552367,12.4746158 C23.9552367,6.15986998 18.8115976,1.02231087 12.4893787,1.02231087'></path>
                  <g transform='translate(7.000000, 7.000000)'>
                    <polygon points='11 0.70490208 10.2951656 0 5.49999993 4.79509779 0.704834305 0 0 0.70490208 4.7951655 5.49999987 0 10.2950977 0.704834305 11 5.49999993 6.20490195 10.2951656 11 11 10.2950977 6.20483437 5.49999987'></polygon>
                  </g>
                </g>
              </svg>
              <div className='sp__lightbox__iframe'>
                <Plyr
                  type="youtube"
                  ref='player'
                  videoId={ lightbox ? video : 'none' }
                  autoplay={true}
                  urls={{
                    youtube: {
                      api: `https://noembed.com/embed?url=${0}`
                    }
                  }}
                />
              </div>
            </div>
          </div>
        }
      </section>
    )
  }
}

export default LatestVideos